// Textur-Fluss ("Texture Flow X/Y" im Material-Menue): die Farb-Textur
// wandert mit dem Scroll-Fortschritt. Versatz = fester Offset + Fortschritt
// (0..1) x Fluss-Tempo. Liefert null, wenn kein Fluss eingestellt ist.
export type TexturFlussOptionen = {
  textureOffsetX?: number | null;
  textureOffsetY?: number | null;
  textureScrollX?: number | null;
  textureScrollY?: number | null;
};

export function texturFlussVersatz(
  opts: TexturFlussOptionen | null | undefined,
  fortschritt: number,
): { x: number; y: number } | null {
  const sx = Number(opts?.textureScrollX ?? 0) || 0;
  const sy = Number(opts?.textureScrollY ?? 0) || 0;
  if (sx === 0 && sy === 0) return null;
  const ox = Number(opts?.textureOffsetX ?? 0) || 0;
  const oy = Number(opts?.textureOffsetY ?? 0) || 0;
  const f = Math.min(1, Math.max(0, Number(fortschritt) || 0));
  return { x: ox + f * sx, y: oy + f * sy };
}
